import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  dark = false
}: SectionCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl sm:mt-12" data-id="element-292" data-mp="3idp1gqyeaktd">
      <CtaButton label={label} data-id="element-293" data-mp="3id6zresyree2" />
      <p className={`mt-3 text-center text-sm ${dark ? 'text-brand-100' : 'text-muted'}`} data-id="element-294" data-mp="3nc9sbzrrbs55">
        One-time payment of <strong className={dark ? 'text-white' : 'text-ink'} data-id="element-295" data-mp="38n3ticwu03xs">$27</strong> · Instant download · 7-day
        guarantee
      </p>
    </div>;
}